import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function NotFoundPage() {
  return (
    <div className="flex flex-col items-center justify-center py-24 text-center gap-4">
      <p className="text-5xl font-bold font-mono text-muted-foreground">404</p>
      <p className="text-sm text-muted-foreground">
        That page is not part of Dashbase.
      </p>
      <Button asChild>
        <Link to="/">Back to the dashboard</Link>
      </Button>
    </div>
  );
}
